import { workSheetConstants } from '../../_constants';

const initialState = { updateWorksheetLoading: true, data: '', error: false };

export function updateWorksheetReducer(state = initialState, action) {
    
    switch (action.type) {
        case workSheetConstants.REQUEST_SHARE_WORKSHEET:
            return {
                updateWorksheetLoading: true,
                data: '',
                error: false
            };
        case workSheetConstants.RECEIVE_SHARE_WORKSHEET:
            return {
                updateWorksheetLoading: false,
                data: action.updateWorksheet,
                error: false
            };
        case workSheetConstants.SHARE_WORKSHEET_ERROR:
            return {
                updateWorksheetLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/workSheet/updateWorksheet.reducer.js